import { CalooAdminConfig } from "../admin";
import { requestSE } from '../request';

const BASE_URL =
    CalooAdminConfig?.googleApi ||
    import.meta.env.VITE_MEEFOD_API_URL;


/**
 * Envía un mensaje a Slack
 */
export async function sendSlackCaloo(userId: string, message: string) {
    try {
        const response = await requestSE(userId).post(
            `${BASE_URL}/sendSlack`,
            { message }
        );

        return response.data;
    } catch (error) {
        console.error('❌ Error sendSlackCaloo:', error);
        return null;
    }
}

/**
 * Registra un log en Kibana
 */
export async function setKibanaLogCaloo(userId: string, log: Record<string, any>) {
    try {
        const response = await requestSE(userId).post(
            `${BASE_URL}/set/kibanaLog`,
            log
        );

        return response.data;
    } catch (error) {
        console.error('❌ Error setKibanaLogCaloo:', error);
        return null;
    }
}